import React, { Component } from 'react'
import { Card, Row, Col } from 'reactstrap'
import values from 'mout/object/values'
import {
  Selector,
  AddButton,
  Header,
  Nav,
  SearchFilter,
} from './ManagePane'
import { InfoCards } from './ManagePane/InfoCard'
import queryString from 'query-string'
import { BeatLoader } from 'react-spinners'


class ManageUsersDistrictAdmin extends Component {
  state = {
    filter: ''
  }

  handleChange = ({ target }) => this.setState({ [target.name]: target.value })

  render() {
    const { districts, schools, educators, match, user, history, location } = this.props
    const { filter } = this.state
    const district = this.props.match.params.id
    const qs = queryString.parse(location.search)
    const actionId = qs.r ? qs.r : ''

    const districtAdmins = values(educators).filter(ed =>
      ed.role === 'District Admin' &&
      ed.schoolDistrict === district
    )

    return (
      <div className='manage-identified district-admin'>

        <Row className='org-info-display'>
          <Col xs='12'>
            {user && districts && schools
              ? <Selector
                districts={districts}
                schools={schools}
                id={district}
                user={user}
                history={history}
                baseLink='/users/manage/district-admins/'
                selectorLevel={'district'}
              />
              : <BeatLoader loading={true} />
            }
          </Col>
        </Row>


        <Row className='page-header'>
          <Col xs='12' sm='6'>
            <Header>Manage District Admins</Header>
          </Col>
          <Col className='add-item district-admin' xs='12' sm='6'>
            <AddButton id={district} role='district-admins'>+ Add a District Admin</AddButton>
          </Col>
        </Row>


        <Row>
          <Col xs='12' sm='8' md='6' xl='4' className='search-item district-admin'>
            <SearchFilter
              placeholder='Search District Admins...'
              filter={filter}
              handleChange={this.handleChange}
            />
          </Col>
        </Row>
        <InfoCards
          records={districtAdmins}
          filter={filter}
          recordType='district-admin'
          actionId={actionId}
          history={history}
          search={location.search}
          user={user}
        />
        <BeatLoader loading={!educators} />
        <AddButton id={district} role='district-admins'>+ Add a District Admin</AddButton>

        {user && user.role === 'Super Administrator' &&
          <Nav back='/users/manage/district-admins' />
        }
      </div>
    )
  }
}

export default ManageUsersDistrictAdmin


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageUsersDistrictAdmin.js